import joi from 'joi';
import { MenuItem } from "@material-ui/core"
import React from "react";
import _ from "lodash";
import dayjs, {Dayjs} from "dayjs";
// @ts-ignore
const TempStars = window.TempStars;

export const roles = [
    {value: '0', text: 'Registered Dental Hygienist'},
    {value: '1', text: 'Dental Assistant'},
]

export const paymentTermsOpts = [
    {id: 1, text:  'Within 24h'},
    {id: 14, text: 'Within 2 Weeks'},
    {id: 30, text: 'Within 1 Month'},
]

export const paymentTermsOpts123Dentist = [
    {id: 1, text:  'Within 24h paid by Corporate'},
]

export const paymentMethodOpts = (country: number, is123Dentist: boolean=false) => {
    if(is123Dentist){
        return [
            {id: 1, text: "Pay Now (TempStars' Payment Processor)"},
        ]
    }
    return [
        {id: 1, text: "Pay Now (TempStars' Payment Processor)"},
        {id: 2, text: country ? 'Check' : 'Cheque'},
        {id: 3, text: 'Electronic Funds Transfer'},
        {id: 4, text: 'Payroll / Temporary Employee'}
    ]
}

export enum Country {
    Canada = 0,
    USA = 1
}

export const JOB_STATUSES = {
    POSTED: 1,
    PARTIAL: 2,
    CONFIRMED: 3,
    COMPLETED: 4,
    OFFER_EXPIRED: 5
}

const ppeErrorMessage = 'To post your shift, please confirm your office complies with workplace safety and infection control regulations.'

export const schema = joi
    .object({
        country: joi.number().label('Country'),
        role: joi.number().label('Role').required(),
        location: joi.number().label('Location').required(),
        startDate: joi.any().custom((value: Dayjs, helper: any) => {
            if (!dayjs(value).isValid())
                return helper.message('Start Date is required.');
            return value && (value.isAfter(dayjs()) || value.isToday()) ? value : helper.message('Please select today’s date or a future date for the Start Date');
        })
            .label('Start Date').required(),
        from: joi.date().label('From').required(),
        to: joi.date().min(joi.ref('from')).label('To').required(),
        proposedRate: joi.number().label('Proposed Rate').required(),
        paymentTerms: joi.number().label('Payment Terms').required(),
        paymentMethod: joi.number().label('Payment Method').required(),
        skills: joi.string().label('Skills').when('role', [
            { is: '0', then: joi.string() },
            { is: '1', then: joi.forbidden() }
        ]),
        instaBook: joi.boolean().label('Insta Book'),
        downtimeUnpaid: joi.boolean().label('Downtime Unpaid').when('role', [
            { is: '0', then: joi.boolean().label('Downtime Unpaid') },
            { is: '1', then: joi.forbidden() }
        ]),
        paysW2: joi.number().label('Working Relationship').when('country', [
            { is: 0, then: joi.forbidden() },
            { is: 1, then: joi.number().required() }
        ]),
        level: joi.number().label('Level').when('country', [{ is: 1, then: joi.forbidden() },
            { is: 0, then: joi.number().when('role', [{ is: '1', then: joi.number().required() },
                    { is: '0', then: joi.forbidden() }]) }]),
        ppe: joi.boolean().label('PPE').valid(true)
            .messages({
                'any.only': ppeErrorMessage,
                'any.required': ppeErrorMessage,
            }).required(),
    })
    .required()

export const timePickerOptions = (date?: string | number | Date, from = 5, to = 23, step = 15) => {
    let timeArray = [];
    if (date instanceof Date && from <= to && to <= 23 && from >= 5 && Number.isInteger(60 / step)) {
        const startDate = new Date(date);
        startDate.setHours(from, 0, 0, 0);

        for (let hoursIterator = from; hoursIterator <= to; hoursIterator++) {
            for (let minutesIterator = 0; minutesIterator < 60; minutesIterator += step) {
                const currentDate = new Date(startDate);
                currentDate.setHours(hoursIterator, minutesIterator);
                timeArray.push(currentDate);
            }
        }
    }
    return timeArray.map((time, index) => (
        <MenuItem key={index} value={time.toString()}>
            {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
        </MenuItem>
    ));
};


export const rateOptions = (jobType: 0 | 1, defaultRate?: number) => {
    const getArrayInRange = (min: number, max: number) => _.range(min, max + 1)
    let minRate;
    let maxRate;
    if(jobType === 1){
        minRate = 17;
        defaultRate = defaultRate ? defaultRate : 25;
        maxRate = 60;
    } else {
        minRate = 35;
        defaultRate = defaultRate ? defaultRate : 50;
        maxRate = 120;
    }
    return getArrayInRange(minRate, maxRate).map((rate) => {
        let label;
        let optionClass;

        return (
            <MenuItem
                key={rate}
                className={optionClass || 'green-rate'}
                value={rate}
                selected={rate === defaultRate}
            >
                {label || `$${rate}/hr`}
            </MenuItem>
        );
    });
}

export const afterPostJobActions = (postedJob: any, jobData: any, countryCode?: number) => {
    let shiftPaymentTerms = '<1 Month';
    if (jobData.job.paymentTerms === 1){
        shiftPaymentTerms = '<24 Hours'
    }
    if (jobData.job.paymentTerms === 14) {
        shiftPaymentTerms = '<2 Weeks'
    }

    let shiftPaymentMethod = 'Pay Now (TempStars\'s Payment Processor)';
    if (jobData.job.paymentMethod === 2) {
        shiftPaymentMethod = Number(countryCode || 0) === 0 ? 'Cheque' : 'Check';
    } else if (jobData.job.paymentMethod === 3) {
        shiftPaymentMethod = 'Electronic Funds Transfer';
    } else if (jobData.job.paymentMethod === 4) {
        shiftPaymentMethod = 'Payroll / Temporary Employee';
    }


    TempStars.Analytics.track( 'post shift', {
        shiftId: postedJob.shiftId,
        isInstabookEnabled: !!jobData.job.Instabook,
        recommendedHourlyRate: parseInt(jobData.job.proposedRate),
        currencyCode: Number(countryCode || 0) === 0 ? 'CAD' : 'USD',
        shiftStartDate: dayjs(jobData.job.from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        shiftEndDate: dayjs(jobData.job.to).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        dentalWorkerType: !!jobData.job.type ? 'Assistant' : 'Hygienist',
        shiftPaymentTerms,
        shiftPaymentMethod,
        dentalOfficeLocationId: jobData.job.locationId,
    } );
}